'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');

class AxiosPermissionsDataProvider {
    constructor(axiosInstance, url = '/api/uibootstrap/permissions') {
        this.axiosInstance = axiosInstance;
        this.url = url;
    }
    loadPermissions(application) {
        return _tslib.__awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.axiosInstance.get(`${this.url}/${encodeURIComponent(application)}`);
                return response.data;
            }
            catch (e) {
                let code = -1;
                let text = e.message;
                const ae = e;
                if (ae.response) {
                    code = ae.response.status;
                    text = ae.response.data;
                }
                throw new Error(`Unable to load permissions: (${code}) ${text}`);
            }
        });
    }
}

exports["default"] = AxiosPermissionsDataProvider;
